<div class="page-container">
  <div class="error_container">
    <p class="http-code">404</p>
    <p class="message">Извините, но запрошенная вами страница не найдена</p>
  </div>
</div>
